import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import { parse, addDays } from "date-fns";
import _ from "lodash";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
import { EntryModule } from "@/store/modules/entry.module";
import EcSelect from "@/components/widgets/EcSelect.vue";
import { DateFormatConstant } from "@/store/DateFormatConstants";
import { SettingModule } from "@/store/modules/settings.module";
let AdvanceSearchComponent = /** @class */ (() => {
    let AdvanceSearchComponent = class AdvanceSearchComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isAdvanceSearchFlapOpen = false;
            this.isSearchIsApplied = false;
            this.dateRangeStart = null;
            this.dateRangeEnd = null;
        }
        get states() {
            return EntryModule.states;
        }
        get types() {
            return EntryModule.types;
        }
        get categories() {
            return EntryModule.categories;
        }
        get statuses() {
            return EntryModule.statuses;
        }
        get tags() {
            return EntryModule.tags;
        }
        get employees() {
            return EntryModule.employees;
        }
        categorySelectionChanged(item) {
            this.entrySearch.categoriesLists.push(item);
        }
        tagSelectionChanged(item) {
            this.entrySearch.tagsLists.push(item);
        }
        typeSelectionChanged(item) {
            this.entrySearch.typeLists.push(item);
        }
        statusSelectionChanged(item) {
            this.entrySearch.statusLists.push(item);
        }
        stateSelectionChanged(item) {
            this.entrySearch.stateLists.push(item);
        }
        Search() {
            EntryModule.AssignAdvanceSearch(this.entrySearch);
            this.isSearchIsApplied = true;
            this.$emit("search", this.entrySearch);
            this.closingAdvanceSearchFlap();
        }
        dateOpenedStartDate() {
            if (this.entrySearch.dateOpenedStartDate != null && this.entrySearch.dateOpenedStartDate != undefined) {
                this.entrySearch.dateOpenedStartDateAsString = this.entrySearch.dateOpenedStartDate;
            }
            else {
                this.entrySearch.dateOpenedStartDateAsString = "";
            }
        }
        dateOpenedEndDate() {
            if (this.entrySearch.dateOpenedEndDate != null && this.entrySearch.dateOpenedEndDate != undefined) {
                this.entrySearch.dateOpenedEndDateAsString = this.entrySearch.dateOpenedEndDate;
            }
            else {
                this.entrySearch.dateOpenedEndDateAsString = "";
            }
        }
        updatedOnStartDate() {
            if (this.entrySearch.updatedOnStartDate != null && this.entrySearch.updatedOnStartDate != undefined) {
                this.entrySearch.updateOnStartDateAsString = this.entrySearch.updatedOnStartDate;
            }
            else {
                this.entrySearch.updateOnStartDateAsString = "";
            }
        }
        updatedOnEndDate() {
            if (this.entrySearch.updatedOnEndDate != null && this.entrySearch.updatedOnEndDate != undefined) {
                this.entrySearch.updateOnEndDateAsString = this.entrySearch.updatedOnEndDate;
            }
            else {
                this.entrySearch.updateOnEndDateAsString = "";
            }
        }
        lastActionStartDate() {
            if (this.entrySearch.lastActionStartDate != null && this.entrySearch.lastActionStartDate != undefined) {
                this.entrySearch.lastActionStartDateAsString = this.entrySearch.lastActionStartDate;
            }
            else {
                this.entrySearch.lastActionStartDateAsString = "";
            }
        }
        lastActionEndDate() {
            if (this.entrySearch.lastActionEndDate != null && this.entrySearch.lastActionEndDate != undefined) {
                this.entrySearch.lastActionEndDateAsString = this.entrySearch.lastActionEndDate;
            }
            else {
                this.entrySearch.lastActionEndDateAsString = "";
            }
        }
        reset() {
            this.isSearchIsApplied = false;
            this.$emit("reset");
        }
        disableLastActionStart(date) {
            if (!this.entrySearch.lastActionEndDate)
                return false;
            const inputDateFormat = this.dateFormat === DateFormatConstant.DateFormat.DateFormatDMY() ? DateFormatConstant.DateFormatClientDMY() : DateFormatConstant.DateFormatClientMDY();
            const endDate = parse(this.entrySearch.lastActionEndDate, inputDateFormat, new Date());
            const startDateLimit = addDays(endDate, -60);
            return date < startDateLimit || date > endDate;
        }
        disableLastActionEnd(date) {
            if (!this.entrySearch.lastActionStartDate)
                return false;
            const inputDateFormat = this.dateFormat === DateFormatConstant.DateFormat.DateFormatDMY() ? DateFormatConstant.DateFormatClientDMY() : DateFormatConstant.DateFormatClientMDY();
            const startDate = parse(this.entrySearch.lastActionStartDate, inputDateFormat, new Date());
            const endDateLimit = addDays(startDate, 60);
            return date > endDateLimit || date < startDate;
        }
        closingAdvanceSearchFlap() {
            this.isAdvanceSearchFlapOpen = false;
            if (this.isSearchIsApplied) {
                this.overrideEntrySearch();
            }
            this.$emit("closeSearch");
        }
        updateEmployee() {
            this.entrySearch.updatedByValue = this.employees.find((employee) => employee.id === this.entrySearch.updatedBy).value;
        }
        showAdvanceSearchFlap() {
            this.isAdvanceSearchFlapOpen = true;
        }
        get isSearchObjEmpty() {
            const isEmpty = Object.values(this.entrySearch).every((value) => {
                if (Array.isArray(value)) {
                    return value.length === 0;
                }
                else {
                    return value === "" || value == null;
                }
            });
            return isEmpty;
        }
        get entryAdvanceSearchData() {
            return EntryModule.entryAdvanceSearchData;
        }
        overrideEntrySearch() {
            if (this.isSearchIsApplied) {
                for (const key in this.entrySearch) {
                    if (this.entryAdvanceSearchData[key] === undefined && this.entrySearch[key] !== undefined) {
                        this.entrySearch[key] = null;
                    }
                    else {
                        this.entrySearch[key] = _.cloneDeep(this.entryAdvanceSearchData[key]);
                    }
                }
            }
        }
        overrideAdvanceSearch() {
            if (this.isSearchIsApplied) {
                for (const key in this.entrySearch) {
                    if (this.entryAdvanceSearchData[key] === undefined && this.entrySearch[key] !== undefined) {
                        this.entrySearch[key] = null;
                    }
                    else {
                    }
                }
            }
        }
        get isClient() {
            return SettingModule.userRole == this.client;
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], AdvanceSearchComponent.prototype, "entrySearch", void 0);
    AdvanceSearchComponent = __decorate([
        Component({
            name: "AdvanceSearchComponent",
            components: {
                simplebar,
                EcSelect,
            },
        })
    ], AdvanceSearchComponent);
    return AdvanceSearchComponent;
})();
export default AdvanceSearchComponent;
